// Angular
import { Component, OnInit,OnDestroy } from '@angular/core';

// Models
import { Theme } from 'app/_models';

// ngx-translate
import { TranslateService } from '@ngx-translate/core';

//Mapper
import { Mapper } from "@nartc/automapper";

import { CountryProfile } from 'app/_mapper/country.profile';
import { ContactPersonProfile } from 'app/_mapper/contactperson.profile';
import { DossierProfile } from 'app/_mapper/dossier.profile';
import { InsureeProfile } from 'app/_mapper/insuree.profile';
import { PolicyProfile } from 'app/_mapper/policy.profile';
import { PartyGenderProfile } from 'app/_mapper/partygender.profile';

// 3rd Part
import { NgForage } from 'ngforage';
import { PureCloudService } from './_services/pure-cloud.service';
import { AuthenticationService } from './_services';
import { ROLES } from './_constants/roles';
import { environment } from 'environments/environment';
import { GlobalErrorHandler } from './app.global-error-handler';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit,OnDestroy{
  public title = 'Site'; 
  private editMode: boolean = false;
  constructor(
    private ngf: NgForage,
    private translate: TranslateService,
    private pureCloudService: PureCloudService,
    private authenticationService: AuthenticationService,
    private globalErrorHandler: GlobalErrorHandler 
  ) {
  
    this.translate.addLangs(['en', 'fr', 'nl', 'de']);
    translate.setDefaultLang('nl');
  
    this.ngf.getItem<Theme>('theme')
      .then(data => {
        if (data && data.language) {
          translate.use(data.language)
        }
      });
 
    Mapper
      .addProfile(PartyGenderProfile)
      .addProfile(CountryProfile)
      .addProfile(ContactPersonProfile)
      .addProfile(InsureeProfile)
      .addProfile(PolicyProfile)
      .addProfile(DossierProfile);
 
  }
  ngOnDestroy(): void {
  this.globalErrorHandler.destroySubject$.unsubscribe();
  }

  ngOnInit()
  {     
    this.getRoles();
    this.getDataFromPureCould();
    this.setGenesysToken();
  }

  setGenesysToken(){
    let url = window.location.href;
    if(url.indexOf('access_token') >=0 && url.indexOf('&expires_in') >=0){
      let token = url.split('access_token=')[1].split('&expires_in')[0];      
        localStorage.setItem(environment.GenesysTokenName, JSON.stringify({ token: token }));
        window.close();
    }
  }

  getRoles() {
    let roles = this.authenticationService.getLocalStorageRoles();
    if (roles != null) {
      this.editMode = roles.find(r => r.authorizationRoleId.trim() == ROLES.DOSSIER_MANAGEMENT && r.operationUpdate == true) != undefined;
    }
  }

  getDataFromPureCould(){
    this.pureCloudService.notifications.subscribe((data : any) => {
      if(data && data.interaction){
        this.pureCloudService.handelCall(data, this.editMode);
      }
    })
  }
}
